import { Box } from 'components'
import styled from 'styled-components'

export const Container = styled(Box)`
  ${({ theme: { colors } }) => `
  background: ${colors('background')};
  min-height: 100vh;
  padding: 1rem;
`}
`

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`

export const Controls = styled(Box)`
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const ControlButton = styled.button`
  ${({ theme: { colors, defaults }, active }) => `
    background: ${active ? colors('link') : colors('chrome')};
    color: ${colors('text')};
    border: none;
    border-radius: ${defaults('radius')};
    padding: 0.75rem 1rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;

    &:hover {
      background: ${colors('link')};
    }
  `}
`

export const SongList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`

export const SongItem = styled.li`
  ${({ theme: { colors, defaults }, isDragging }) => `
    padding: 1rem;
    margin: 0.5rem 0;
    background: ${colors('chrome')};
    border-radius: ${defaults('radius')};
    display: flex;
    align-items: center;
    gap: 1rem;
    ${isDragging ? `
      opacity: 0.8;
      box-shadow: 0 5px 15px rgba(0,0,0,0.3);
    ` : ''}
  `}
`

export const DragHandle = styled.div`
  cursor: grab;
  padding: 0.5rem;
  touch-action: none;

  &:active {
    cursor: grabbing;
  }
`

export const SongDetails = styled.div`
  flex: 1;
`

export const SongTitle = styled.h4`
  ${({ theme: { colors } }) => `
    color: ${colors('link')};
    margin: 0;
  `}
`

export const DeleteButton = styled.div`
  cursor: pointer;
  padding: 0.5rem;
`

export const MoveButton = styled.button`
  ${({ theme: { colors, defaults } }) => `
    background: ${colors('background')};
    color: ${colors('text')};
    border: 1px solid ${colors('chrome')};
    border-radius: ${defaults('radius')};
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    font-size: 0.75rem;

    &:hover {
      background: ${colors('link')};
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  `}
`

export const MoveControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`
